<template>
  <transition name="el-fade-in-linear">
    <div v-show="menuVisible" class="menu" :style="{ paddingBottom: bannerHeight + 'px' }">
      <div class="menu__action">
        <el-button type="text" size="mini" @click="onClose">
          <i class="mdi mdi-close"></i>
          <br />
          <span class="text-xs">{{ $t('common.action.close') }}</span>
        </el-button>
      </div>
      <div class="menu__inner">
        <div v-if="isVisibleRankMember" class="menu__section">
          <ul class="menu__section__list">
            <li class="menu__section__list__rankitem">
              <span class="menu-no-wrap">{{ full_name }}</span>
              <br />
              <span class="menu-no-wrap font-bold pl-4">{{ rank_name }}</span>
            </li>
          </ul>
        </div>
        <div v-for="(section, sectionIndex) in menus" :key="sectionIndex" class="menu__section">
          <div v-if="!hideTitle(section.children)" class="menu__section__title">{{ section.title }}</div>
          <ul class="menu__section__list">
            <li
              v-show="!menu.hidden"
              v-for="(menu, menuIndex) in section.children"
              :key="`${sectionIndex}_${menuIndex}`"
              :class="['menu__section__list__item', { 'pl-4': menu.isSubmenu }]"
            >
              <router-link class="flex items-center menu-height" v-if="menu.url" :to="menu.url" @click.native="onClose">
                <img v-show="menu.img" class="mr-2" :src="menu.img" />
                <span class="menu-no-wrap">{{ menu.title }}</span>
                <span v-if="menu.specialText" :class="menu.specialClass">{{
                  getSpecialMenuValue(menu.specialText)
                }}</span>
              </router-link>
              <a class="flex" v-else @click.prevent="menu.onClick">
                <img v-show="menu.img" class="mr-2" :src="menu.img" />{{ menu.title }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="menu__banner" ref="banner" @click="toProductsList">
        <img
          class="menu__banner__img-pc"
          :src="Constants.SHOP_CONFIG.BANNER_IMG"
          alt=""
          onerror="this.style.display='none'"
        />
        <img
          class="menu__banner__img-sp"
          :src="Constants.SHOP_CONFIG.BANNER_IMG_SP"
          alt=""
          onerror="this.style.display='none'"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import mixinAuth from '@/mixins/auth'
import liff from '@line/liff'
import { MenuService, ShopService } from '@/services'
import { ENV_KEY } from '@/constants/env'
import store from '@/store'
import { isVisibleRankMemberShopDetail } from '@/utils'

export default {
  mixins: [mixinAuth],
  props: {
    visible: Boolean,
  },
  data() {
    return {
      bannerHeight: 0,
      menuMypageTopOn: false,
      menuSubscriptionOn: false,
      menuPurchaseOn: false,
      menuCustomerOn: false,
      menuShippingOn: false,
      menuPaymentOn: false,
      isVisibleRankMember: false,
    }
  },
  computed: {
    full_name() {
      if (this.user) {
        return this.Utils.helper.fullName(this.user.name01, this.user.name02) + this.$t('ec-line009.memberRank.nameSub')
      } else {
        return this.$t('common.hyphenSeparator')
      }
    },
    rank_name() {
      if (this.user) {
        return this.user.rank_name ? this.user.rank_name : this.$t('common.hyphenSeparator')
      } else {
        return this.$t('common.hyphenSeparator')
      }
    },
    menuVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    menus() {
      return this.getMenus()
    },
    hasInvalidSubscription() {
      return this.$store.getters['menu/getInvalidSubscription'] ? this.$t('menu.subscriptionError') : ''
    },
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
  },
  watch: {
    menuVisible(val) {
      if (val) {
        this.getBannerHeight()
      }
    },
  },
  methods: {
    async getVisibleRankMemberShopDetail() {
      const shopID = store.getters['env/GET_KEY'](ENV_KEY.SHOP_ID)
      const { data } = await ShopService.getShopInfo(shopID)
      if (data) {
        this.isVisibleRankMember = isVisibleRankMemberShopDetail(data) && this.user && this.user.rank_use_flag
      }
    },
    getBannerHeight() {
      let banner = this.$refs.banner

      this.$nextTick(() => {
        this.bannerHeight = banner.clientHeight
      })
    },
    toProductsList() {
      if (this.$route.name !== 'EC_LINE001') {
        this.$router.push({ name: 'EC_LINE001' }).then(() => this.onClose())
      } else {
        this.onClose()
      }
    },
    onClose() {
      this.menuVisible = false
    },
    hideTitle(childs) {
      if (!childs) return true

      return childs.every((item) => item.hidden)
    },
    async fetchEnable() {
      try {
        if (this.$store.getters['auth/isLogin']) {
          const { data } = await MenuService.getMenuEnableinfo({})
          if (data) {
            this.menuMypageTopOn = data.menu_mypage_top_on
            this.menuSubscriptionOn = data.menu_subscription_on
            this.menuPurchaseOn = data.menu_purchase_on
            this.menuCustomerOn = data.menu_customer_on
            this.menuShippingOn = data.menu_shipping_on
            this.menuPaymentOn = data.menu_payment_on
          }
        }
      } catch (error) {
        this.handleError(error)
      }
    },
    getMenus() {
      this.getVisibleRankMemberShopDetail()
      this.fetchEnable()
      this.mypageChildren = []
      this.mypageChildren.push({
        isSubmenu: true,
        url: this.$routePage.EC_LINE031,
        title: this.$t('common.menu.login'),
        hidden: this.user,
      })
      if (this.menuMypageTopOn) {
        this.mypageChildren.push({
          isSubmenu: true,
          url: this.$routePage.EC_LINE009,
          title: this.$t('common.menu.topMyPage'),
          hidden: !this.user,
        })
      }
      if (this.menuPurchaseOn && this.corporateFlag) {
        this.mypageChildren.push({
          isSubmenu: true,
          url: this.$routePage.EC_LINE042,
          title: this.$t('common.menu.purchaseInfo'),
          hidden: !this.user,
        })
      }
      if (this.menuSubscriptionOn) {
        this.mypageChildren.push({
          isSubmenu: true,
          url: this.$routePage.EC_LINE014,
          title: this.$t('common.menu.subscriptionInfo'),
          hidden: !this.user,
          specialText: 'hasInvalidSubscription',
          specialClass: 'ml-2 text-red-150 text-xs leading-normal ',
        })
      }
      if (this.menuPurchaseOn && !this.corporateFlag) {
        this.mypageChildren.push({
          isSubmenu: true,
          url: this.$routePage.EC_LINE042,
          title: this.$t('common.menu.purchaseInfo'),
          hidden: !this.user,
        })
      }
      if (this.menuCustomerOn) {
        this.mypageChildren.push({
          isSubmenu: true,
          url: this.$routePage.EC_LINE010,
          title: this.$t('common.menu.memberInfo'),
          hidden: !this.user,
        })
      }
      if (this.menuShippingOn) {
        this.mypageChildren.push({
          isSubmenu: true,
          url: this.$routePage.EC_LINE027,
          title: this.$t('common.menu.shippingInfo'),
          hidden: !this.user,
        })
      }
      if (this.menuPaymentOn) {
        this.mypageChildren.push({
          isSubmenu: true,
          url: this.$routePage.EC_LINE012,
          title: this.$t('common.menu.paymentInfo'),
          hidden: !this.user,
        })
      }
      return [
        {
          title: this.$t('common.menu.mypage'),
          children: this.mypageChildren,
        },
        {
          title: this.$t('common.menu.others'),
          children: [
            {
              isSubmenu: true,
              url: this.$routePage.EC_LINE023,
              title: this.$t('common.menu.faq'),
            },
            {
              isSubmenu: true,
              url: this.$routePage.EC_LINE024,
              title: this.$t('common.menu.specifiedCommercialTransactionsLaw'),
            },
            {
              isSubmenu: true,
              url: this.$routePage.EC_LINE025,
              title: this.$t('common.menu.privacyPolicy'),
            },
            {
              isSubmenu: true,
              url: this.$routePage.EC_LINE026,
              title: this.$t('common.menu.companyProfile'),
            },
            // {
            //   onClick: () => {},
            //   title: this.$t('common.menu.inquiries'),
            // },
            // {
            //   url: this.$routePage.EC_LINE020,
            //   title: this.$t('common.menu.mailContact'),
            //   img: SHOP_CONFIG.MAIL_CONTACT_MENU,
            //   isSubmenu: true,
            // },
            // {
            //   onClick: () => {
            //     window.location.href = `${this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}${
            //       process.env.VUE_APP_PREFIX
            //     }${this.$routePage.EC_LINE036}`
            //   },
            //   title: this.$t('common.menu.lineContact'),
            //   img: SHOP_CONFIG.LINE_CONTACT_MENU,
            //   isSubmenu: true,
            // },
            {
              onClick: async () => {
                this.onClose()
                try {
                  liff && liff.logout()
                } catch (err) {
                  //TODO
                }
                await this.handleLogout()
              },
              hidden: !this.$store.getters['auth/isLogin'],
              title: this.$t('common.menu.logout'),
              isSubmenu: true,
            },
          ],
        },
      ]
    },
    getSpecialMenuValue(key) {
      return this[key]
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/the-menu.scss';
</style>
